<template>
  <div class="">

    <Head />

    <div class="main listMain siteMap">

      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('網站導覽') }}</li>
          </ol>
        </div>
      </nav>

      <div class="listMain_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ $t('網站導覽') }}</h2>
          </div>

          <div class="box">

            <div class="text_box">

              <p>{{ $t('網站的主要樣版內容分為三個大區塊：') }}
                <br>
                {{ $t('(1)上方區塊 (2)中央內容區塊 (3)頁尾網頁資訊') }}
                <br>
                <br>
                {{ $t('本網站的導盲磚﹝Accesskey,也稱為快速鍵﹞設定如下：') }}
                <br>
                {{ $t('Alt +U：移至網頁最上方之項目位置。') }}
                <br>
                {{ $t('Alt +C：主要內容區，此區塊呈現網頁主要內容資訊。') }}
                <br>
                {{ $t('Alt +B：下方頁尾網頁資訊。') }}
              </p>
            </div>

            <ul class="siteMap_menu">
              <li class="menu_li" v-for="(item, index) in menuItems" :key="index">

                <!-- 有子選單：用 a 觸發 dropdown，不跳轉 -->
                <a v-if="item.children" class="menu_link none" role="button" :title="item.title">
                  {{ item.title }}
                </a>

                <!-- 沒有子選單 + 外部連結 -->
                <a v-else-if="item.isExternal" class="menu_link" :href="item.link" :target="item.target" :title="item.title">
                  {{ item.title }}
                </a>

                <!-- 沒有子選單 + 內部連結 -->
                <router-link v-else-if="item.link" class="menu_link" :to="item.link" role="button" :title="item.title">
                  {{ item.title }}
                </router-link>

                <!-- 沒有子選單也沒有連結 -->
                <span v-else class="menu_link" :title="item.title">
                  {{ item.title }}
                </span>

                <!-- 第二層選單 -->
                <div v-if="item.children" class="children_box">

                  <ul class="children_ul">
                    <li class="children_li" v-for="(child, cIndex) in item.children" :key="cIndex">
                      <!-- 子選單外部連結 -->
                      <a v-if="child.isExternal" class="children_link" :href="child.link" :target="child.target" :title="child.title">
                        <p>{{ child.title }}</p>
                      </a>
                      <!-- 子選單內部連結 -->
                      <router-link v-else-if="child.link" class="children_link" :to="child.link" :title="child.title">
                        <p>{{ child.title }}</p>
                      </router-link>
                      <!-- 子選單無連結 -->
                      <span v-else class="children_link" :title="child.title">
                        <p>{{ child.title }}</p>
                      </span>
                    </li>
                  </ul>

                </div>
              </li>
            </ul>




          </div>


        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'


export default {
  name: 'SiteMap',
  components: {
    Head,
    Footer,

    AccesskeyLink,

  },

  data() {
    return {

      // 主選單
      menuItems: [],

    };
  },

  async mounted() {
    // 載入網站導覽選單資料
    await this.fetchSiteMapLayout();
  },

  watch: {
    '$i18n.locale': async function() {
      // 語系切換時重新載入選單資料
      await this.fetchSiteMapLayout();
    }
  },

  methods: {

    // 轉換前端語系名稱為後端格式
    convertLocaleForBackend(frontendLocale) {
      const localeMap = {
        'zh-TW': 'zh-tw',
        'en': 'en-us',
        'ja': 'ja-jp'
      };
      return localeMap[frontendLocale] || 'zh-tw';
    },
    // API: 取得網站導覽版面配置
    async fetchSiteMapLayout() {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetLayout?TabKey=Other&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得網站導覽版面配置，清空選單資料');
          this.menuItems = [];
          return;
        }
        
        const layout = await response.json();
        
        if (layout.layoutItems && Array.isArray(layout.layoutItems)) {
          // 尋找 ItemKey 為 SiteMap 的項目
          const siteMapItem = layout.layoutItems.find(item => item.itemKey === 'SiteMap');
          
          if (siteMapItem && siteMapItem.referenceId) {
            await this.fetchSiteMapMenuData(siteMapItem.referenceId);
          } else {
            this.menuItems = [];
          }
        } else {
          this.menuItems = [];
        }
      } catch (error) {
        console.error('載入網站導覽版面配置失敗:', error);
        this.menuItems = [];
      }
    },

    // API: 取得網站導覽選單資料
    async fetchSiteMapMenuData(menuId) {
      try {
        const backendLocale = this.convertLocaleForBackend(this.$i18n.locale);
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/Frontend/GetMenuData?MEId=${menuId}&locale=${backendLocale}`;
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          console.warn('無法取得網站導覽選單資料，清空選單資料');
          this.menuItems = [];
          return;
        }
        
        const menu = await response.json();
        
        if (menu.data && Array.isArray(menu.data)) {
          // 轉換選單資料格式
          this.menuItems = menu.data.map(item => this.convertMenuItem(item));
        } else {
          this.menuItems = [];
        }
      } catch (error) {
        console.error('載入網站導覽選單資料失敗:', error);
        this.menuItems = [];
      }
    },

    // 轉換選單項目格式
    convertMenuItem(item) {
      const menuItem = {
        title: item.text
      };

      // 產生連結
      const link = this.generateLink(item.data);
      if (link) {
        menuItem.link = link;
      }

      // 處理外部連結
      if (item.data?.type === 3) {
        menuItem.isExternal = true;
        menuItem.target = item.data?.target || '_blank';
      }

      // 處理子選單（注意 API 返回的是 childs 不是 children）
      if (item.childs && Array.isArray(item.childs) && item.childs.length > 0) {
        menuItem.children = item.childs.map(child => ({
          title: child.text,
          link: this.generateLink(child.data),
          isExternal: child.data?.type === 3,
          target: child.data?.target || '_blank'
        }));
      }

      return menuItem;
    },

    // 根據 data.type 產生對應的連結
    generateLink(data) {
      if (!data) return '';

      switch (data.type) {
        case 0:
          // 目錄，不產生連結
          return '';
        case 1:
          // 文章分類
          return data.cid ? `/Category/${data.cid}` : '';
        case 2:
          // 文章
          return data.pid ? `/Post/${data.pid}` : '';
        case 3:
          // 外部連結
          return data.url || '';
        default:
          return '';
      }
    },
  },

}

</script>
